import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/custom-toast.css';
import Input from '../../../components/form/Input';
import InputCadastro from '../../../components/form/InputCadastro';
import InputCadastroComIcone from '../../../components/form/InputCadastroComIcone';
import InputCelular from '../../../components/form/InputCelular';
import InputRazaoSocial from '../../../components/form/InputRazaoSocial';
import InputSenha from '../../../components/form/InputSenha';
import { abreAlertaDialog } from '../../../components/modal/AlertaDialog';
import { createFormSchemasPJ } from './FormSchemaPJ';

const FormCadastroPJEstrangeiroComAn8 = ({ onSubmit, data }) => {
  const { t } = useTranslation();
  const { formSchemaPJAN8 } = createFormSchemasPJ(t);
  const methods = useForm({ resolver: yupResolver(formSchemaPJAN8) });
  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };

  const [ddi, setDdi] = useState();
  const atribuirDDI = (event) => {
    setDdi(event.target.value);
  };

  const [desabilitarCampo, setDesabilitarCampo] = useState(true);
  const [desabilitarSalvar, setDesabilitarSalvar] = useState(true);

  const [radioToken, setRadioToken] = useState('E');
  const handleRadioToken = (event) => {
    setRadioToken(event.target.value);
  };
  const [isCheckedTermo, setIsCheckedTermo] = useState(false);
  const handleTermo = () => {
    setIsCheckedTermo(!isCheckedTermo);
    if (!isCheckedTermo) {
      setDesabilitarSalvar(false);
    } else {
      setDesabilitarSalvar(true);
    }
  };
  const handleReset = () => {
    setDesabilitarCampo(true);
    const form = document.getElementById('FormCadastro');
    const campos = form.querySelectorAll('input, select');
    campos.forEach((campo) => {
      campo.value = '';
    });
  };
  const navigate = useNavigate();
  function handleSubmit(data) {
    if (!isCheckedTermo) {
      abreAlertaDialog(t('cadastro.messages.validation.terms_required'));
    } else {
      const telefoneFormatado = data.foneMovel.replace(/[\(\)\-\s]/g, '');
      const dadosCompletosPJ = {
        an8: data.an8,
        numeroContrato: data.numeroContrato,
        idCorreios: data.idcorreios,
        sediadaForaBrasil: 'S',
        foneMovel: telefoneFormatado,
        dddMovel: data.dddMovel,
        ddiMovel: data.ddiMovel,
        tipo: 'PJ',
        termoAceito: 'S',
        nome: data.nome.trim().toUpperCase(),
        senha: data.senha,
        email: data.email.trim(),
        meioEnvio: data.meioEnvio,
        situacaoAtual: 'P',
        nomeFantasia: data.nomeFantasia.trim().toUpperCase(),
      };
      onSubmit(dadosCompletosPJ);
    }
  }
  return (
    <>
      <hr />

      <form id="FormCadastro" onSubmit={methods.handleSubmit(handleSubmit)}>
        <InputCadastro
          type="text"
          id="an8"
          name="an8"
          label={t('cadastro.forms.labels.an8')}
          maxLength="8"
          //onBlur={handleAN8}
          {...formMethods}
        />
        <InputCadastro
          type="text"
          id="numeroContrato"
          name="numeroContrato"
          label={t('cadastro.forms.labels.contrato')}
          maxLength="10"
          {...formMethods}
        />
        <InputCadastro
          type="text"
          id="idcorreios"
          name="idcorreios"
          placeholder=""
          maxLength="15"
          label={t('cadastro.forms.labels.create_login_detailed_an8')}
          {...formMethods}
          //disabled={desabilitarCampo}
        />
        <InputRazaoSocial
          type="text"
          id="nome"
          name="nome"
          placeholder=""
          label={t('cadastro.forms.labels.company_name')}
          {...formMethods}
          //disabled={desabilitarCampo}
        />
        <InputCadastro
          type="text"
          id="nomeFantasia"
          name="nomeFantasia"
          label={t('cadastro.forms.labels.trade_name')}
          placeholder=""
          {...formMethods}
          //disabled={desabilitarCampo}
        />
        <InputCadastroComIcone
          type="email"
          id="email"
          name="email"
          label={t('cadastro.forms.labels.email')}
          placeholder="email@email.com"
          iconName="ic-carta"
          {...formMethods}
          //disabled={desabilitarCampo}
        />
        <div className="container-telefone">
          <InputCadastroComIcone
            type="text"
            className="col-1"
            campoClassName="campo-ddi"
            iconName="ic-adicionar"
            id="ddiMovel"
            name="ddiMovel"
            maxLength="2"
            placeholder="99"
            label={t('cadastro.forms.labels.ddi')}
            {...formMethods}
            onBlur={atribuirDDI}
            //disabled={desabilitarCampo}
          />
          <InputCadastro
            type="text"
            className="col-1"
            campoClassName="campo-ddd"
            id="dddMovel"
            name="dddMovel"
            maxLength="3"
            label={t('cadastro.forms.labels.ddd')}
            placeholder="999"
            {...formMethods}
            // onBlur={atribuirDDI}
            //disabled={desabilitarCampo}
          />
          <InputCelular
            type="tel"
            id="foneMovel"
            name="foneMovel"
            label={t('cadastro.forms.labels.mobile')}
            {...formMethods}
            //disabled={desabilitarCampo}
          />
        </div>
        <InputSenha
          id="senha"
          name="senha"
          label={
            t('cadastro.forms.labels.password') +
            ' ' +
            t('cadastro.messages.validation.password_requirements')
          }
          placeholder=""
          {...formMethods}
          //disabled={desabilitarCampo}
        />
        <InputSenha
          id="confirmaSenha"
          name="confirmaSenha"
          label={t('cadastro.forms.labels.confirm_password')}
          placeholder=""
          {...formMethods}
          //disabled={desabilitarCampo}
        />

        <p className="legenda txt-obrigatorios">
          {t('cadastro.forms.labels.required_fields')}
        </p>

        <hr />

        <div className="receber-token radio-container">
          <p className="">
            {' '}
            {t('cadastro.messages.info.token_registration_method', {
              defaultValue:
                'Como deseja receber o token de confirmação de cadastro?',
            })}
          </p>

          <label className="radio">
            <Input
              type="radio"
              id="E"
              name="meioEnvio"
              value="E"
              checked={radioToken === 'E'}
              onChange={handleRadioToken}
              //disabled={desabilitarCampo}
              {...formMethods}
            />
            <div className="subtitulo-p">
              {t('cadastro.forms.options.email_option')}
            </div>
          </label>

          <label className="radio">
            <Input
              type="radio"
              id="C"
              name="meioEnvio"
              value="C"
              checked={radioToken === 'C'}
              onChange={handleRadioToken}
              //disabled="true"
              //disabled={desabilitarCampo}
              {...formMethods}
            />
            <div className="subtitulo-p">
              {t('cadastro.forms.options.mobile_option')}
            </div>
          </label>
        </div>

        <hr />
        <label className="input-checkbox">
          <Input
            type="checkbox"
            id="termo"
            name="termo"
            checked={isCheckedTermo}
            onChange={handleTermo}
            //disabled={desabilitarCampo}
          />
          <div>
            {t('cadastro.messages.info.privacy_acceptance_read', {
              defaultValue: 'Li e aceito a',
            })}
            &ensp;
            <a
              className="txt-link"
              href="https://www.correios.com.br/falecomoscorreios/politica-de-privacidade-e-notas-legais"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('cadastro.legal.privacy_policy')}
            </a>
          </div>
        </label>
        <br />

        <div className="btns-row">
          <button
            id="btn-prosseguir"
            type="submit"
            className="btn-pre primario"
            disabled={desabilitarSalvar}
          >
            {t('cadastro.forms.buttons.register')}
          </button>
          <button
            id="btn-limpar"
            type="reset"
            className="btn-txt"
            onClick={handleReset}
            //disabled={desabilitarCampo}
          >
            {t('cadastro.forms.buttons.clear')}
          </button>
          <button
            id="btn-voltar"
            type="button"
            className="btn-txt"
            onClick={() => navigate('/login')}
          >
            {t('cadastro.forms.buttons.cancel')}
          </button>
        </div>
      </form>
    </>
  );
};
export default FormCadastroPJEstrangeiroComAn8;
